export const DEFAULT_WALLETCONNECT_PROJECT_ID = '6113382c2e587bff00e2b5c3d68531f3';
export const UNMERGEABLE_WALLETS = ['nova', 'nova wallet', 'coinwallet', 'coin wallet', 'superwallet', 'super wallet'];
export const NAME_OVERRIDES = { bitget: 'Bitget Wallet' };
// Slugified names of wallets to exclude (duplicates / unwanted entries).
export const SLUGS_TO_FILTER = ['okx-wallet-1', 'ready', 'yowallet', 'safewallet'];
export const FEATURED_WALLETS_IDS = [
    'metamask',
    'argent',
    'rainbow',
    'bitkeep',
    'okx-wallet',
];
